/**
 * TOUR-03 lot 2b — adresse et coordonnées de l'agence (point de départ du simulateur).
 * L'API sérialise latitude/longitude en CHAÎNES (comme Conteneur) et refuse un nombre (400) ;
 * les deux ensemble ou aucune.
 */

const num = (v) => (v === '' || v == null || Number.isNaN(Number(v)) ? null : Number(v));

/** Nombre → chaîne à 7 décimales (« 47.2184000 »). */
export const coordEnChaine = (n) => Number(n).toFixed(7);

/** Une agence a des coordonnées exploitables si ses deux champs sont numériques. */
export const agenceALesCoordonnees = (agence) => num(agence?.latitude) != null && num(agence?.longitude) != null;

const vide = (v) => v === '' || v == null;

/**
 * Latitude et longitude : toutes deux numériques (±90 / ±180) ou toutes deux vides — sinon le submit est bloqué
 * (on n'envoie jamais un null silencieux à la place d'une saisie invalide).
 * @returns {{latitude?: string, longitude?: string}} messages d'erreur par champ
 */
export function erreursCoordonnees(values) {
    const lat = values.latitude, lon = values.longitude;
    if (vide(lat) && vide(lon)) return {};
    const e = {};
    if (vide(lat) || num(lat) == null || Math.abs(num(lat)) > 90) e.latitude = 'Latitude : nombre entre -90 et 90 (les deux coordonnées ou aucune).';
    if (vide(lon) || num(lon) == null || Math.abs(num(lon)) > 180) e.longitude = 'Longitude : nombre entre -180 et 180 (les deux coordonnées ou aucune).';
    return e;
}

/** Valeurs du formulaire depuis l'agence de l'API. */
export function valeursAgence(agence) {
    return {
        libelle: agence?.libelle ?? '',
        codeCouleur: agence?.codeCouleur ?? '#000000',
        adresse: agence?.adresse ?? '',
        latitude: agence?.latitude ?? '',
        longitude: agence?.longitude ?? '',
    };
}

/** Corps du POST/PATCH : coordonnées en chaînes, vide → null pour les deux (l'une sans l'autre n'est pas envoyée). */
export function construirePayloadAgence(values) {
    const lat = num(values.latitude), lon = num(values.longitude);
    const adresse = (values.adresse ?? '').trim();
    return {
        libelle: values.libelle,
        codeCouleur: values.codeCouleur,
        adresse: adresse === '' ? null : adresse,
        latitude: lat != null && lon != null ? coordEnChaine(lat) : null,
        longitude: lat != null && lon != null ? coordEnChaine(lon) : null,
    };
}
